import { render, staticRenderFns } from "./detail-match.vue?vue&type=template&id=701dde7e&scoped=true"
import script from "./detail-match.vue?vue&type=script&lang=js"
export * from "./detail-match.vue?vue&type=script&lang=js"
import style0 from "./detail-match.vue?vue&type=style&index=0&id=701dde7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701dde7e",
  null
  
)

export default component.exports